module.exports = __webpack_public_path__ + "media/light.f72c008a.mp3";